export default __webpack_public_path__ + "static/media/icon-transfer.63858773.svg";